<template>
<div class="chapter">
<div class="inner_page">
<p class="p0"><span class="t2">Beware of Psychics Box Set</span></p>
<p class="p0">By Holly Day</p>
<p class="p2"><a id="a4"></a> </p>
<p class="p2"><a href="#/004#a58">How to Hook a Vampire</a></p>
<p class="p4"><a href="#/004#a59">Chapter 1</a></p>
<p class="p4"><a href="#/005#a65">Chapter 2</a></p>
<p class="p4"><a href="#/006#a67">Chapter 3</a></p>
<p class="p4"><span href="#/007#a73" title="Link target outside of Sample">Chapter 4</span></p>
<p class="p4"><span href="#/008#a75" title="Link target outside of Sample">Chapter 5</span></p>
<p class="p4"><span href="#/009#a78" title="Link target outside of Sample">Chapter 6</span></p>
<p class="p4"><span href="#/010#a79" title="Link target outside of Sample">Chapter 7</span></p>
<p class="p4"><span href="#/011#a81" title="Link target outside of Sample">Chapter 8</span></p>
<p class="p4"><span href="#/012#a83" title="Link target outside of Sample">Chapter 9</span></p>
<p class="p4"><span href="#/013#a84" title="Link target outside of Sample">Chapter 10</span></p>
<p class="p4"><span href="#/014#a86" title="Link target outside of Sample">Chapter 11</span></p>
<p class="p4"><span href="#/015#a89" title="Link target outside of Sample">Chapter 12</span></p>
<p class="p4"><span href="#/016#a90" title="Link target outside of Sample">Chapter 13</span></p>
<p class="p4"><span href="#/017#a93" title="Link target outside of Sample">Epilogue</span></p>
<p class="p4"> </p>
<p class="p2"><span href="#/018#a94" title="Link target outside of Sample">The Bear Claw</span></p>
<p class="p4"><span href="#/018#a95" title="Link target outside of Sample">Chapter 1</span></p>
<p class="p4"><span href="#/019#a99" title="Link target outside of Sample">Chapter 2</span></p>
<p class="p4"><span href="#/020#a101" title="Link target outside of Sample">Chapter 3</span></p>
<p class="p4"><span href="#/021#a103" title="Link target outside of Sample">Chapter 4</span></p>
<p class="p4"><span href="#/022#a104" title="Link target outside of Sample">Chapter 5</span></p>
<p class="p4"><span href="#/023#a106" title="Link target outside of Sample">Chapter 6</span></p>
<p class="p4"><span href="#/024#a108" title="Link target outside of Sample">Chapter 7</span></p>
<p class="p4"><span href="#/025#a110" title="Link target outside of Sample">Chapter 8</span></p>
<p class="p4"><span href="#/026#a112" title="Link target outside of Sample">Chapter 9</span></p>
<p class="p4"><span href="#/027#a113" title="Link target outside of Sample">Chapter 10</span></p>
<p class="p4"><span href="#/028#a115" title="Link target outside of Sample">Chapter 11</span></p>
<p class="p4"><span href="#/029#a116" title="Link target outside of Sample">Chapter 12</span></p>
<p class="p4"><span href="#/030#a118" title="Link target outside of Sample">Chapter 13</span></p>
<p class="p4"><span href="#/031#a120" title="Link target outside of Sample">Chapter 14</span></p>
<p class="p4"><span href="#/032#a121" title="Link target outside of Sample">Chapter 15</span></p>
<p class="p4"><span href="#/033#a123" title="Link target outside of Sample">Chapter 16</span></p>
<p class="p4"><span href="#/034#a125" title="Link target outside of Sample">Chapter 17</span></p>
<p class="p4"><span href="#/035#a127" title="Link target outside of Sample">Chapter 18</span></p>
<p class="p4"><span href="#/036#a129" title="Link target outside of Sample">Chapter 19</span></p>
<p class="p4"><span href="#/037#a131" title="Link target outside of Sample">Chapter 20</span></p>
<p class="p4"><span href="#/038#a133" title="Link target outside of Sample">Chapter 21</span></p>
<p class="p4"><span href="#/039#a134" title="Link target outside of Sample">Chapter 22</span></p>
<p class="p4"><span href="#/040#a135" title="Link target outside of Sample">Chapter 23</span></p>
<p class="p4"><span href="#/041#a136" title="Link target outside of Sample">Chapter 24</span></p>
<p class="p4"><span href="#/042#a137" title="Link target outside of Sample">Epilogue</span></p>
<p class="p4"> </p>
<p class="p2"><span href="#/043#a138" title="Link target outside of Sample">Batshit Bassel</span></p>
<p class="p4"><span href="#/043#a139" title="Link target outside of Sample">Chapter 1</span></p>
<p class="p4"><span href="#/044#a140" title="Link target outside of Sample">Chapter 2</span></p>
<p class="p4"><span href="#/045#a141" title="Link target outside of Sample">Chapter 3</span></p>
<p class="p4"><span href="#/046#a142" title="Link target outside of Sample">Chapter 4</span></p>
<p class="p4"><span href="#/047#a143" title="Link target outside of Sample">Chapter 5</span></p>
<p class="p4"><span href="#/048#a144" title="Link target outside of Sample">Chapter 6</span></p>
<p class="p4"><span href="#/049#a145" title="Link target outside of Sample">Chapter 7</span></p>
<p class="p4"><span href="#/050#a146" title="Link target outside of Sample">Epilogue</span><a href="#/#a57"></a></p>
<h1 class="h10"><a id="ncx77"></a><a id="a57"></a> </h1>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 003.vue?25938788